// src/SettingsContext.js
import React, { createContext, useState, useEffect } from 'react';

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const defaultSettings = {
    exchanges: {
      binance: true,
      lbank: true,
      htx: true,
      mexc: true,
      gate: true,
      bybit: true,
      bingx: true,
      bitget: true,
      ourbit: true,
      kucoin: true,
    },
    tokenBlacklist: '',
    tokenWhitelist: '',
    minProfit: 0.5,
    maxProfit: 1000,
    minVolume: 0,
    minSpreadValueForSound: 5,
    soundEnabled: false,
    exchangeBlacklists: {
      binance: { buy: '', sell: '' },
      lbank: { buy: '', sell: '' },
      htx: { buy: '', sell: '' },
      mexc: { buy: '', sell: '' },
      gate: { buy: '', sell: '' },
      bybit: { buy: '', sell: '' },
      bingx: { buy: '', sell: '' },
      bitget: { buy: '', sell: '' },
      ourbit: { buy: '', sell: '' },
      kucoin: { buy: '', sell: '' },
    },
  };

  const [settings, setSettings] = useState(() => {
    const savedSettings = localStorage.getItem('settings');
    return savedSettings ? JSON.parse(savedSettings) : defaultSettings;
  });

  const [telegramId, setTelegramId] = useState(''); // Добавьте поле для telegram_id

  useEffect(() => {
    const tryGetTelegramId = () => {
      const tg = window.Telegram?.WebApp;
      const userId = tg?.initDataUnsafe?.user?.id;
      if (userId) {
        setTelegramId(userId);
        return true;
      }
      return false;
    };

    if (tryGetTelegramId()) return;

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (tryGetTelegramId() || attempts >= 150) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    localStorage.setItem('settings', JSON.stringify(settings));
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, telegramId }}>
      {children}
    </SettingsContext.Provider>
  );
};
